import CompetenceCard from './CompetenceCard.vue';

export default CompetenceCard;



// WEBPACK FOOTER //
// ./src/pages/competences/card/index.ts